import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../common/AutoBindComponent";
import IndienenForm from "./IndienenForm";
import IndienenPageHelper from "./IndienenPageHelper";

import * as types from "../../constants/ComponentConstants";
import * as indienenActions from "../../actions/indienenActions";
import * as layoutActions from "../../actions/layoutActions";
import * as documentActions from "../../actions/documentActions";


class IndienenPage extends AutoBindComponent {

    constructor(props, context) {
        super(props, context);

        this.state = {
            pdf: {}
        };

        this.pageHelper = new IndienenPageHelper(this);
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    componentWillUnmount() {
        this.pageHelper.unmount();
    }

    componentWillReceiveProps(nextProps) {
        this.pageHelper.update(nextProps);
    }

    handleOnSave(event) {
        this.pageHelper.onSave(event);
    }

    handleOnGeneratePdf() {
        this.pageHelper.onGeneratePdf();
    }

    isReadyToRender() {
        // entity not loaded? not ready yet...
        if (!this.props.indienen || !this.props.indienen.dossierId) {
            return false;
        }

        return true;
    }

    render() {
        if (!this.isReadyToRender()) {
            return null;
        }
        return (<IndienenForm
            indienen={this.props.indienen}
            onSave={this.handleOnSave}
            disabled={this.disabled}
            color={types.COLOR_GREEN}
            pdf={this.state.pdf}
            isPollingDocument={this.state.timer ? true : false}
            generatePdf={this.handleOnGeneratePdf}
        />);
    }
}

function mapStateToProps(state, ownProps) {
    const infrastructuurId = state.infrastructuren[0] !== undefined ? state.infrastructuren[0].id : null;

    return {
        indienen: state.indienen,
        disabled: state.settings.lockAllDossiers,
        infrastructuurId: infrastructuurId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        confirmIndienen: bindActionCreators(indienenActions.confirmIndienen, dispatch),
        loadIndienen: bindActionCreators(indienenActions.loadIndienen, dispatch),
        loadLayout: bindActionCreators(layoutActions.loadIndienenPageLayout, dispatch),
        getContent: bindActionCreators(documentActions.getContent, dispatch),
        generatePdf: bindActionCreators(indienenActions.generatePdf, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(IndienenPage);
